import AddPage from './AddPage.js'
import { BasePage as CngBasePage } from 'cng-web-lib'
import EditPage from './EditPage.js'
import React from 'react'
import TablePage from './TablePage.js'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ACEOceanTranslationProvider from '../contexts/ACEOceanTranslationContext.js'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <ACEOceanTranslationProvider>
        <TablePage showNotification={showSnackbar} {...props} />
      </ACEOceanTranslationProvider>
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <ACEOceanTranslationProvider>
        <AddPage showNotification={showSnackbar} {...props} />
      </ACEOceanTranslationProvider>
    )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <ACEOceanTranslationProvider>
        <EditPage showNotification={showSnackbar} {...props} />
      </ACEOceanTranslationProvider>
    )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage renderPage={(showSnackbar) => (
      <ACEOceanTranslationProvider>
        <ViewPage showNotification={showSnackbar} {...props} />
      </ACEOceanTranslationProvider>
    )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedTablePage as TablePage
}
